export default __webpack_public_path__ + "static/phorest-3f7afc0ccb8dedff05dc6ea147d98708.png";